import { render } from "./EventoAtmosferico.vue?vue&type=template&id=5f7b2e63&scoped=true"
import script from "./EventoAtmosferico.vue?vue&type=script&lang=js"
export * from "./EventoAtmosferico.vue?vue&type=script&lang=js"

import "./EventoAtmosferico.vue?vue&type=style&index=0&id=5f7b2e63&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7b2e63"]])

export default __exports__